import { EntityDto } from '../shared/entity.dto';

export class ConversationNerWithValueQueryItemDto extends EntityDto {
  operator: number;
  categoryId: number;
  categoryItemId: number;
  field: number;
  internalId: number;
  parentInternalId: number;
  queryId: number;
  sideId: number;
  sideCode: string;
  multiple: boolean;
  nerId: number;
  term: string;
}
